import type { AnyGameDefinition } from './types.ts';

export interface GameRegistry {
  register(game: AnyGameDefinition): void;
  get(id: string): AnyGameDefinition | undefined;
  list(): readonly AnyGameDefinition[];
}

export function createRegistry(): GameRegistry {
  const games = new Map<string, AnyGameDefinition>();
  return {
    register(game) {
      if (games.has(game.id)) throw new Error(`Game id already registered: ${game.id}`);
      if (game.minSeats < 1 || game.maxSeats < game.minSeats) {
        throw new Error(`Invalid seat range for ${game.id}: ${game.minSeats}..${game.maxSeats}`);
      }
      games.set(game.id, game);
    },
    get: (id) => games.get(id),
    list: () => [...games.values()],
  };
}
